import React, { useMemo, useCallback } from 'react';
import debounce from 'lodash/debounce';

import ToggleContainer from './Toggle';
import SearchContainer from './Search';
import MenusContainer from './Menus';
import PinnedMenusContainer from './PinnedMenus';
import InfoVersion from './InfoVersion';

import SidebarDivider from './Divider';
import { isAbleToHoverQuickly } from './utils';
import { usePin, useSidebar } from 'react/hooks/sidebar.hook';

function Sidebar() {
  let lastDebouncedFunction = null;

  const {
    isCollapsed,
    isHovered,
    isSearching,
    setHover
  } = useSidebar();

  const { pinnedMenus } = usePin();

  const sidebarClassName = useMemo(() => {
    let SIDEBAR_STATE = '';

    if (isSearching && (!isHovered || isHovered) && !isCollapsed) {
      SIDEBAR_STATE = '';
    } else if ((isCollapsed && isHovered) || isSearching) {
      SIDEBAR_STATE = 'hovered';
    } else if (isCollapsed) {
      SIDEBAR_STATE = 'collapsed';
    }

    return SIDEBAR_STATE;
  }, [isCollapsed, isHovered, isSearching]);

  const debouncedHover = useCallback((e, value) => {
    if (!isCollapsed) {
      return;
    }

    if (lastDebouncedFunction) {
      lastDebouncedFunction.cancel();
    }

    const debounceTime = isAbleToHoverQuickly(e) ? 100 : 600;

    lastDebouncedFunction = debounce(() => {
      setHover(value);
    }, debounceTime);

    lastDebouncedFunction();
  }, [isCollapsed]);

  return (
    <div
      id="sidebar"
      data-testid="sidebar"
      className={sidebarClassName}
      onMouseEnter={(e) => debouncedHover(e, true)}
      onMouseLeave={(e) => debouncedHover(e, false)}
    >
      <ToggleContainer />
      <SearchContainer />
      <div className="sidebar-scrollable-content">
        <PinnedMenusContainer />
        <SidebarDivider pinnedMenusTotal={pinnedMenus.length} />

        <MenusContainer />
        <InfoVersion />
      </div>
    </div>
  );
}

export default Sidebar;
